import { computeChecksumMd5 } from '@/components/form/dynamic-field/utils';

const MAX_FILE_NAME_LENGTH = 64;

function shortenFileName(fileName: string): string {
  if (fileName.length <= MAX_FILE_NAME_LENGTH) {
    return fileName;
  }

  const lastDotIndex = fileName.lastIndexOf('.');

  if (lastDotIndex <= 0) {
    return fileName.slice(0, MAX_FILE_NAME_LENGTH);
  }

  const fileNameWithoutEnding = fileName.slice(0, lastDotIndex);
  const fileEnding = fileName.slice(lastDotIndex + 1);

  if (fileEnding.length >= MAX_FILE_NAME_LENGTH) {
    return fileName.slice(0, MAX_FILE_NAME_LENGTH);
  }

  const maxNameLength = MAX_FILE_NAME_LENGTH - 1 - fileEnding.length;
  return fileNameWithoutEnding.slice(0, maxNameLength) + '.' + fileEnding;
}

export async function processFileForUpload(file: File): Promise<{
  name: string;
  md5_hash: string;
  file: File;
}> {
  const name = shortenFileName(file.name);
  const md5_hash = await computeChecksumMd5(file);
  return { name, md5_hash, file };
}
